import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Div from 'components/Div'
import Form from 'components/Form'

const ButtonWrapper = styled(Div).attrs((props) => ({
  marginLeft: 'medium'
}))`
  flex-grow: 1;
`

export const AddToCart = ({
  disabled = false,
  buttonText = '',
  withInput = false,
  loading = false
}) => {
  return (
    <React.Fragment>
      <Form.QuantitySelector
        name='totalQuantity'
        min={1}
        withInput={withInput}
      />
      <ButtonWrapper>
        <Form.SubmitButton
          disabled={disabled || loading}
          fullWidth
          loading={loading}
        >
          {buttonText}
        </Form.SubmitButton>
      </ButtonWrapper>
    </React.Fragment>
  )
}

AddToCart.propTypes = {
  withInput: PropTypes.bool,
  disabled: PropTypes.bool,
  buttonText: PropTypes.string,
  loading: PropTypes.bool
}
